import Vue from 'vue'
import Router from 'vue-router'
import {abilitiesPlugin} from '@casl/vue'
import defineAbilitiesFor from '@/helpers/ability'
import store from '@/store'

// Containers
const DefaultContainer = () => import('@/containers/DefaultContainer')

// Views
const Dashboard = () => import('@/views/Dashboard')

// Views - Pages
const Page404 = () => import('@/views/pages/Page404')
const Page500 = () => import('@/views/pages/Page500')
const Login = () => import('@/views/pages/Login')
const Register = () => import('@/views/pages/Register')

// Users
const Users = () => import('@/views/users/Users')
const User = () => import('@/views/users/User')

// RRHH
const UsersList = () => import('@/views/users/List')
const NewUser = () => import('@/views/users/New')
const EditUser = () => import('@/views/users/Edit')

// ADMINISTRADOR

// REQUERIMIENTOS
const ImportUnassignedRequeriments = () => import('@/views/requeriments/ImportUnassigned')
const ImportAssignedRequeriments = () => import('@/views/requeriments/ImportAssigned')
const ExportUnassignedRequeriments = () => import('@/views/requeriments/ExportUnassigned')
const ExportAssignedRequeriments = () => import('@/views/requeriments/ExportAssigned')
const StowUnassignedRequeriments = () => import('@/views/requeriments/StowUnassigned')
const StowAssignedRequeriments = () => import('@/views/requeriments/StowAssigned')
const DetailRequeriment = () => import('@/views/requeriments/Detail')
const DetailPortRequeriment = () => import('@/views/requeriments/DetailPort')
const EditRequeriment = () => import('@/views/requeriments/Edit')
const PortageList = () => import('@/views/portages/List')
const PortageNew = () => import('@/views/portages/New')
const PortageEdit = () => import('@/views/portages/Edit')
const PortageDetail = () => import('@/views/portages/RqList')
const PortageFinish = () => import('@/views/portages/Finish')
const PortageProgress = () => import('@/views/portages/Progress')
const AllServices = () => import('@/views/services/All')
const Approved = () => import('@/views/services/Approved')
const ExpiratedRqs = () => import('@/views/requeriments/Expiration')
const AllRqs = () => import('@/views/requeriments/All')
const StatusLogsReport = () => import('@/views/requeriments/Logs');
const Empty = () => import('@/views/portages/Empty')

// TRASLADO DE VACIOS
const VoidsAssigned = () => import('@/views/requeriments/voids/Assigned')
const EditVoidService = () => import('@/views/services/voids/Edit')
const VoidsUnassigned = () => import('@/views/requeriments/voids/Unassigned')
const VoidsUnapproved = () => import('@/views/requeriments/voids/Unapproved')
const NewVoid = () => import('@/views/requeriments/voids/New')
const EditVoid = () => import('@/views/requeriments/voids/Edit')
const DetailVoid = () => import('@/views/requeriments/voids/Detail')

const PortList = () => import('@/views/ports/List')
// SERVICE
const DetailService = () => import('@/views/services/Detail')
// const NewService = () => import('@/views/services/New')

// PROVIDERS
const ProviderList = () => import ('@/views/providers/List')
const Assistance = () => import ('@/views/providers/Assistance')
const RatioAssistance = () => import ('@/views/providers/RatioAssistance')
const NewProvider = () => import ('@/views/providers/New')
const EditProvider = () => import ('@/views/providers/Edit')

// MAINTENANCE
const OtList = () => import ('@/views/maintenance/List')
const NewOt = () => import ('@/views/maintenance/New')
const EditOt = () => import ('@/views/maintenance/Edit')

// FLEET
const FleetList = () => import('@/views/fleet/List')
const FleetStatusList = () => import('@/views/fleet/StatusList')
const NewFleet = () => import('@/views/fleet/New')
const EditFleet = () => import('@/views/fleet/Edit')
const FuelList = () => import('@/views/fuel/List')
const NewFuel = () => import('@/views/fuel/New')
const IncidentList = () => import('@/views/incidents/List')
const Payment = () => import('@/views/providers/Payment')
const Rates = () => import('@/views/providers/Rates')
const Sinisters = () => import('@/views/sinisters/Sinisters')
// CART
const CartList = () => import('@/views/carts/List')
const NewCart = () => import('@/views/carts/New')
const EditCart = () => import('@/views/carts/Edit')

// EXPIRATED
const UserExpirated = () => import('@/views/expirations/Users')
const TruckExpirated = () => import('@/views/expirations/Trucks')

// CLIENTS
const NewRequeriment = () => import('@/views/client/services/New')
const EditService = () => import('@/views/client/services/Edit')
const DraftRequeriment = () => import('@/views/client/services/Draft')
const PendingRequeriment = () => import('@/views/client/services/Pending')
const InProgressRequeriment = () => import('@/views/client/services/InProgress')
const HistoryRequeriment = () => import('@/views/client/services/History')

// CRM
const CompanyList = () => import('@/views/company/List')
const NewCompany = () => import('@/views/company/New')
const EditCompany = () => import('@/views/company/Edit')
const CompanyDetail = () => import('@/views/company/Detail')
const NewEmployee = () => import('@/views/company/NewUser')
const EditEmployee = () => import('@/views/company/EditUser')

const MovementList = () => import('@/views/movements/List')

// MAP
const MapView = () => import('@/views/map/Tracking')

// ACCOUNT
const Account = () => import('@/views/account/Account')

// Zone
const Zone = () => import('@/views/zone/Zone')

// Liquidacion
const Liquidacion = () => import('@/views/payments/Payments')

Vue.use(Router)

const router = new Router({
  mode: 'history', // https://router.vuejs.org/api/#mode
  linkActiveClass: 'open active',
  scrollBehavior: () => ({y: 0}),
  routes: [
    {
      path: '/admin',
      redirect: '/dashboard',
      name: 'Home',
      component: DefaultContainer,
      children: [
        {
          path: '/dashboard',
          name: 'Dashboard',
          component: Dashboard,
          meta: {
            requiresAuth: true,
            resource: 'Dashboard'
          }
        },
        {
          path: '/account',
          name: 'Cuenta personal',
          component: Account,
          meta: {
            requiresAuth: true,
            resource: 'Account'
          }
        },
        {
          path: '/movements/list',
          name: 'Movimientos Internos',
          component: MovementList,
          meta: {
            requiresAuth: true,
            resource: 'Movements'
          }
        },
        {
          path: 'services',
          name: 'Servicios',
          component: {
            render(c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: '/services/detail/:id',
              name: 'Detalle de Servicio',
              component: DetailService,
              meta: {
                resource: 'Requeriments',
                requiresAuth: true
              }
            },
            // {
            //   path: '/services/add',
            //   name: 'Nuevo Servicio',
            //   component: NewService,
            //   meta: {
            //     resource: 'Requeriments',
            //     requiresAuth: true
            //   }
            // }
          ]
        },
        {
          path: 'requeriments',
          name: 'Servicios',
          component: {
            render(c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: '/requeriments/finish',
              name: 'Requerimientos Terminados',
              component: AllRqs,
              meta: {
                resource: 'Requeriments',
                action: 'view',
                requiresAuth: true
              }
            },
            {
              path: '/fleet/status',
              name: 'Estado de la flota',
              component: FleetStatusList,
              meta: {
                resource: 'Requeriments',
                action: 'manage',
                requiresAuth: true
              }
            },
            {
              path: '/requeriments/import',
              name: 'Importaciones',
              redirect: '/requeriments/import/unassigned',
              component: {
                render(c) {
                  return c('router-view')
                }
              },
              children: [
                {
                  path: '/requeriments/import/unassigned',
                  name: 'Sin Asignar',
                  component: ImportUnassignedRequeriments,
                  meta: {
                    resource: 'Requeriments',
                    action: 'view',
                    requiresAuth: true
                  }
                },
                {
                  path: '/requeriments/import/assigned',
                  name: 'Asignados',
                  component: ImportAssignedRequeriments,
                  meta: {
                    resource: 'Requeriments',
                    action: 'view',
                    requiresAuth: true
                  }
                },
                {
                  path: '/requeriments/import/detail/:id',
                  name: 'Detalle de requerimiento',
                  component: DetailRequeriment,
                  meta: {
                    resource: 'Requeriments',
                    action: 'read',
                    requiresAuth: true
                  }
                }
              ],
            },
            {
              path: '/requeriments/export',
              name: 'Exportaciones',
              redirect: '/requeriments/export/unassigned',
              component: {
                render(c) {
                  return c('router-view')
                }
              },
              children: [
                {
                  path: '/requeriments/export/unassigned',
                  name: 'Sin Asignar',
                  component: ExportUnassignedRequeriments,
                  meta: {
                    resource: 'Requeriments',
                    action: 'view',
                    requiresAuth: true
                  }
                },
                {
                  path: '/requeriments/export/assigned',
                  name: 'Asignados',
                  component: ExportAssignedRequeriments,
                  meta: {
                    resource: 'Requeriments',
                    action: 'view',
                    requiresAuth: true
                  }
                },
                {
                  path: '/requeriments/export/detail/:id',
                  name: 'Detalle de requerimiento',
                  component: DetailRequeriment,
                  meta: {
                    resource: 'Requeriments',
                    action: 'read',
                    requiresAuth: true
                  }
                },
                {
                  path: '/requeriments/status_logs',
                  name: 'Reporte de Estados',
                  component: StatusLogsReport,
                  meta: {
                    resource: 'Requeriments',
                    action: 'manage',
                    requiresAuth: true
                  },
                },
              ],
            },
            {
              path: '/requeriments/stow',
              name: 'Arrumajes',
              redirect: '/requeriments/stow/unassigned',
              component: {
                render(c) {
                  return c('router-view')
                }
              },
              children: [
                {
                  path: '/requeriments/stow/unassigned',
                  name: 'Sin Asignar',
                  component: StowUnassignedRequeriments,
                  meta: {
                    resource: 'Requeriments',
                    action: 'manage',
                    requiresAuth: true
                  }
                },
                {
                  path: '/requeriments/stow/assigned',
                  name: 'Asignados',
                  component: StowAssignedRequeriments,
                  meta: {
                    resource: 'Requeriments',
                    action: 'manage',
                    requiresAuth: true
                  }
                },
                {
                  path: '/requeriments/stow/detail/:id',
                  name: 'Detalle de requerimiento',
                  component: DetailRequeriment,
                  meta: {
                    resource: 'Requeriments',
                    action: 'read',
                    requiresAuth: true
                  }
                }
              ],
            }
          ]
        },
        {
          path: '/voids/redeliveries',
          name: 'Traslado de vacíos',
          redirect: '/voids/redeliveries/unassigned',
          component: {
            render(c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: '/voids/:void/unassigned',
              name: 'Sin Asignar',
              component: VoidsUnassigned,
              meta: {
                resource: 'Voids',
                action: 'view',
                requiresAuth: true
              }
            },
            {
              path: '/voids/edit/:id',
              name: 'Editar Servicio de translado',
              component: EditVoidService,
              meta: {
                resource: 'Voids',
                action: 'manage',
                requiresAuth: true
              }
            },
            {
              path: '/voids/:void/unapproved',
              name: 'Pendientes de aprobación',
              component: VoidsUnapproved,
              meta: {
                resource: 'Voids',
                action: 'view',
                requiresAuth: true
              }
            },
            {
              path: '/voids/:void/assigned',
              name: 'Asignados',
              component: VoidsAssigned,
              meta: {
                resource: 'Voids',
                action: 'view',
                requiresAuth: true
              }
            },
            {
              path: '/voids/:void/new',
              name: 'Nuevo traslado de vacío',
              component: NewVoid,
              meta: {
                resource: 'Voids',
                action: 'add',
                requiresAuth: true
              }
            },
            {
              path: '/voids/:void/edit/:id',
              name: 'Editar traslado de vacío',
              component: EditVoid,
              meta: {
                resource: 'Voids',
                action: 'manage',
                requiresAuth: true
              }
            },
            {
              path: '/voids/:void/detail/:id',
              name: 'Detalle',
              component: DetailVoid,
              meta: {
                resource: 'Voids',
                action: 'view',
                requiresAuth: true
              }
            }
          ]
        },
        {
          path: 'portage',
          name: 'Porteo',
          component: {
            render(c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: '/ports',
              name: 'Puertos',
              component: PortList,
              meta: {
                resource: 'Requeriments',
                requiresAuth: true
              }
            },
            {
              path: '/empty_containers',
              name: 'Contenedores vacíos',
              component: Empty,
              meta: {
                resource: 'Requeriments',
                requiresAuth: true
              }
            },
            {
              path: '/portage/list',
              name: 'Porteo',
              component: PortageList,
              meta: {
                resource: 'Requeriments',
                requiresAuth: true
              }
            },
            {
              path: '/portage/progress',
              name: 'Avance',
              component: PortageProgress,
              meta: {
                resource: 'Requeriments',
                requiresAuth: true
              }
            },
            {
              path: '/portage/finish',
              name: 'Finalizados',
              component: PortageFinish,
              meta: {
                resource: 'Requeriments',
                requiresAuth: true
              }
            },
            {
              path: '/portage/new',
              name: 'Nuevo Porteo',
              component: PortageNew,
              meta: {
                resource: 'Requeriments',
                requiresAuth: true
              }
            },
            {
              path: '/portage/edit/:id',
              name: 'Editar Porteo',
              component: PortageEdit,
              meta: {
                resource: 'Requeriments',
                requiresAuth: true
              }
            },
            {
              path: '/portage/detail/:id',
              name: 'Detalle de Porteo',
              component: PortageDetail,
              meta: {
                resource: 'Requeriments',
                requiresAuth: true
              }
            },
            {
              path: '/services/all-pending',
              name: 'Listado',
              component: AllServices,
              meta: {
                resource: 'Requeriments',
                requiresAuth: true
              }
            },
            {
              path: '/services/approved',
              name: 'Listado',
              component: Approved,
              meta: {
                resource: 'Requeriments',
                requiresAuth: true
              }
            },
            {
              path: '/requeriments/all',
              name: 'Listado',
              component: AllServices,
              meta: {
                resource: 'Requeriments',
                requiresAuth: true

              }
            },
            {
              path: '/requeriments/detail/:id',
              name: 'Detalle de requerimiento',
              component: DetailPortRequeriment,
              meta: {
                resource: 'Requeriments',
                action: 'read',
                requiresAuth: true
              }
            }
          ]
        },
        {
          path: '/expiration',
          name: 'Por vencer',
          component: ExpiratedRqs,
          meta: {
            resource: 'Requeriments',
            requiresAuth: true
          }
        },
        {
          path: '/expirated',
          name: 'Por vencer',
          component: {
            render(c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: '/expirated/users',
              name: 'Usuarios',
              component: UserExpirated,
              meta: {
                resource: 'Expirated',
                requiresAuth: true
              }
            },
            {
              path: '/expirated/trucks',
              name: 'Flota',
              component: TruckExpirated,
              meta: {
                resource: 'Expirated',
                requiresAuth: true
              }
            }
          ]
        },
        {
          path: '/fleet',
          name: 'Gestor de Flota',
          redirect: '/fleet/list',
          component: {
            render(c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: '/fleet/providers/list',
              name: 'Proveedores',
              component: ProviderList,
              meta: {
                resource: 'Providers',
                requiresAuth: true
              }
            },
            {
              path: '/fleet/maintenance/new/:id',
              name: 'Mantenimiento',
              component: NewOt,
              meta: {
                resource: 'Maintenance',
                requiresAuth: true
              }
            },
            {
              path: '/fleet/maintenance/edit/:id',
              name: 'Mantenimiento',
              component: EditOt,
              meta: {
                resource: 'Maintenance',
                requiresAuth: true
              }
            },
            {
              path: '/fleet/maintenance/list/:type',
              name: 'Mantenimiento',
              component: OtList,
              meta: {
                resource: 'Maintenance',
                requiresAuth: true
              }
            },
            {
              path: '/fleet/providers/new',
              name: 'Nuevo proveedor',
              component: NewProvider,
              meta: {
                resource: 'Providers',
                requiresAuth: true
              }
            },
            {
              path: '/fleet/providers/edit/:id',
              name: 'Editar proveedores',
              component: EditProvider,
              meta: {
                resource: 'Providers',
                requiresAuth: true
              }
            },
            {
              path: '/fleet/list',
              name: 'Flota',
              component: FleetList,
              meta: {
                resource: 'Trucks',
                requiresAuth: true
              }
            },
            {
              path: '/fleet/new',
              name: 'Nuevo Camión',
              component: NewFleet,
              meta: {
                resource: 'Trucks',
                requiresAuth: true
              }
            },
            {
              path: '/fleet/edit/:id',
              name: 'Editar Camión',
              component: EditFleet,
              meta: {
                resource: 'Trucks',
                requiresAuth: true
              }
            },
            {
              path: '/fleet/fuel',
              name: 'Tanqueo',
              component: FuelList,
              meta: {
                resource: 'Fuels',
                action: 'view',
                requiresAuth: true
              }
            },
            {
              path: '/fleet/fuel/new',
              name: 'Nuevo Tanqueo',
              component: NewFuel,
              meta: {
                resource: 'Fuels',
                action: 'add',
                requiresAuth: true
              }
            },
            {
              path: '/fleet/incidents',
              name: 'Reporte de fallos',
              component: IncidentList,
              meta: {
                resource: 'Incidents',
                requiresAuth: true
              }
            },
            {
              path: '/fleet/sinister',
              name: 'Siniestros',
              component: Sinisters,
              meta: {
                resource: 'Sinisters',
                requiresAuth: true
              }
            }
          ]
        },
        {
          path: '/zones',
          name: 'Gestor de Zonas',
          redirect: '/zones/list',
          component: {
            render(c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: '/zones/list',
              name: 'Zonas',
              component: Zone,
              meta: {
                resource: 'Zones',
                requiresAuth: true
              }
            },
          ]
        },
        {
          path: '/liquidacion',
          name: 'Gestor de liquidación',
          redirect: '/liquidacion/list',
          component: {
            render(c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: '/liquidacion/list',
              name: 'Liquidación',
              component: Liquidacion,
              meta: {
                resource: 'Liquidación',
                requiresAuth: true
              }
            },
          ]
        },
        {
          path: '/assistance',
          name: 'Asistencia',
          redirect: '/assistance/list',
          component: {
            render(c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: '/assistance/list',
              name: 'Asistencia',
              component: Assistance,
              meta: {
                resource: 'Trucks',
                requiresAuth: true
              }
            },
            {
              path: '/assistance/report',
              name: 'Reporte asistencia',
              component: RatioAssistance,
              meta: {
                resource: 'Trucks',
                requiresAuth: true
              }
            }
          ]
        },
        {
          path: '/cart',
          name: 'Gestor de Flota',
          redirect: '/cart/list',
          component: {
            render(c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: '/cart/list',
              name: 'Flota',
              component: CartList,
              meta: {
                resource: 'Carts',
                requiresAuth: true
              }
            },
            {
              path: '/cart/new',
              name: 'Nueva Carreta',
              component: NewCart,
              meta: {
                resource: 'Carts',
                requiresAuth: true
              }
            },
            {
              path: '/cart/edit/:id',
              name: 'Editar Carreta',
              component: EditCart,
              meta: {
                resource: 'Carts',
                requiresAuth: true
              }
            }
          ]
        },
        {
          path: '/crm',
          name: 'CRM',
          redirect: '/company/list',
          component: {
            render(c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: '/company/list',
              name: 'Empresas',
              component: CompanyList,
              meta: {
                resource: 'Company',
                requiresAuth: true
              }
            },
            {
              path: '/company/new',
              name: 'Nueva Empresa',
              component: NewCompany,
              meta: {
                resource: 'Company',
                requiresAuth: true
              }
            },
            {
              path: '/company/edit/:id',
              name: 'Editar empresa',
              component: EditCompany,
              meta: {
                resource: 'Company',
                requiresAuth: true
              }
            },
            {
              path: '/company/detail/:id',
              name: 'Detalle empresa',
              component: CompanyDetail,
              meta: {
                resource: 'Company',
                requiresAuth: true
              }
            },
            {
              path: '/company/:company/new/user',
              name: 'Nuevo empleado',
              component: NewEmployee,
              meta: {
                resource: 'Company',
                requiresAuth: true
              }
            },
            {
              path: '/company/edit/user/:id',
              name: 'Editar empleado',
              component: EditEmployee,
              meta: {
                resource: 'Company',
                requiresAuth: true
              }
            },
          ]
        },
        {
          path: '/rrhh',
          name: 'Recursos Humanos',
          redirect: '/rrhh/users',
          component: {
            render(c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: '/rrhh/users',
              name: 'Personal',
              component: UsersList,
              meta: {
                resource: 'User',
                requiresAuth: true
              }
            },
            {
              path: '/rrhh/users/new',
              name: 'Nuevo Personal',
              component: NewUser,
              meta: {
                resource: 'User',
                requiresAuth: true
              }
            },
            {
              path: '/rrhh/users/edit/:id',
              name: 'Editar Personal',
              component: EditUser,
              meta: {
                resource: 'User',
                requiresAuth: true
              }
            }
          ]
        },
        {
          path: '/payments',
          name: 'Pago de variable',
          component: Payment,
          meta: {
            resource: 'Payment',
            action: 'manage',
            requiresAuth: true
          }
        },
        {
          path: '/rates',
          name: 'Tarifario',
          component: Rates,
          meta: {
            resource: 'Rates',
            action: 'manage',
            requiresAuth: true
          }
        },
        {
          path: '/tracking',
          name: 'Mapa',
          component: MapView,
          meta: {
            resource: 'Map',
            action: 'view',
            requiresAuth: true
          }
        },
        {
          path: '/services/new',
          name: 'Nuevo requerimiento',
          component: NewRequeriment,
          meta: {
            resource: 'Requeriments',
            action: 'create',
            requiresAuth: true
          }
        },
        {
          path: '/service/edit/:id',
          name: 'Actualizar servicio',
          component: EditService,
          meta: {
            resource: 'service',
            action: 'edit',
            requiresAuth: true
          }
        },
        {
          path: '/requeriment/edit/:id',
          name: 'Actualizar requerimiento',
          component: EditRequeriment,
          meta: {
            resource: 'service',
            action: 'edit',
            requiresAuth: true
          }
        },
        {
          path: '/services/draft',
          name: 'Borradores',
          component: DraftRequeriment,
          meta: {
            resource: 'Requeriments',
            action: 'view',
            requiresAuth: true
          }
        },
        {
          path: '/services/pending',
          name: 'Servicios pendientes',
          component: PendingRequeriment,
          meta: {
            resource: 'Requeriments',
            action: 'view',
            requiresAuth: true
          }
        },
        {
          path: '/requeriments/in-progress',
          name: 'Requerimientos en curso',
          component: InProgressRequeriment,
          meta: {
            resource: 'Requeriments',
            action: 'view',
            requiresAuth: true
          }
        },
        {
          path: '/requeriments/history',
          name: 'Historial de requerimientos',
          component: HistoryRequeriment,
          meta: {
            resource: 'Requeriments',
            action: 'view',
            requiresAuth: true
          }
        },
      ]
    },
    {
      path: '/',
      redirect: '/login',
      name: 'Pages',
      component: {
        render(c) {
          return c('router-view')
        }
      },
      children: [
        {
          path: '/login',
          name: 'Login',
          component: Login,
          meta: {
            requiresAuth: false
          }
        },
        {
          path: '404',
          name: 'Page404',
          component: Page404,
          meta: {
            requiresAuth: false
          }
        },
        {
          path: '500',
          name: 'Page500',
          component: Page500,
          meta: {
            requiresAuth: false
          }
        },
        {
          path: 'register',
          name: 'Register',
          component: Register,
          meta: {
            requiresAuth: false
          }
        }
      ]
    }
  ]
})

router.beforeEach((to, from, next) => {
  let currentUser = store.getters['user/user']
  const abilities = defineAbilitiesFor(currentUser)
  let canNavigate = abilities.can(to.meta.action || 'read', to.meta.resource)
  let requiresAuth = to.meta.requiresAuth || false
  Vue.use(abilitiesPlugin, abilities)

  let isAuth = localStorage.getItem('token') ? true : false

  console.log('canNavigate: ', canNavigate, to.meta.resource, to.meta.action || 'read')
  console.log('requireAuth: ', requiresAuth)
  console.log('isAuth: ', isAuth)

  if (isAuth) {
    if (!canNavigate || !requiresAuth) {
      return next('/dashboard')
    }
  } else {
    if (requiresAuth) {
      return next('/login')
    }
  }

  next()
})

export default router
